import React from 'react';
import ReactDOM from 'react-dom';
var Inframap = require('./olmap.js');

export default class Olmap extends React.Component {
	constructor(props) {
		super(props);
		this.map = null;
		this.mapAlreadyShown = false;
	}
	componentDidMount() {
		if (this.mapAlreadyShown === false) {
			var mapel = ReactDOM.findDOMNode(this);
			var lpsdata = {lps: window.datastore.lps, id: this.props.id, misc: window.datastore.lps_misc};
			
			switch(this.props.mapPurpose) {
			case "selectlivingPlaceAddress":
				var infmap = new Inframap.default(mapel, this.props.basemapAtType, lpsdata);
				break;
			case "displayRoutesToInfrastructure":
				var infmap = new Inframap.default(mapel, this.props.basemapAtType, null, this.props.routeGeoData);
				break;
			case "selectDailyTargetAddress":
				var infmap = new Inframap.default(mapel, this.props.basemapAtType, lpsdata, null, this.props.id_daily);
				break;
			}
			
			
			
			infmap.init();
			this.map = infmap;
			this.mapAlreadyShown = true;
			console.log('map initialized')
		}
	  }
	  render() {
		  return <div id={'map-'+this.props.id} className={this.props.styleclass}>{ this.props.children }</div>;
		  }
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/olmapview.js